import React, { Component } from "react";
import "../style/FilterCards.css";
import Search from "./Search";
import tags from "../big-text/tags";
import RenderCheckboxes from "./RenderCheckboxes";
import CheckboxHolder from "./CheckboxHolder";
import TabletDropdown from "./TabletDropdown";
import { set } from "lodash";

class FilterCards extends Component {
  constructor(props) {
    super(props);
    // const { pdfs } = this.props;
    const voicings = tags.voicings;
    const composers = tags.composers;
    const liturgicalSeason = tags.liturgicalSeason;
    const massParts = tags.massParts;
    // const misc = tags.misc;
    const scripture = tags.scripture;
    this.state = {
      selectedCategories: [],
      massParts,
      composers,
      liturgicalSeason,
      voicings,
      scripture,
    };
    this.addCategory = this.addCategory.bind(this);
    this.removeCategory = this.removeCategory.bind(this);
  }
  addCategory(categoryToAdd) {
    this.setState(
      (prevState) => {
        return {
          selectedCategories: [...prevState.selectedCategories, categoryToAdd],
        };
      },
      () => console.log(this.state)
    );
    // CALL THE PARENT COMPONENT AND MODIFY STATE
    this.props.addSearchQuery(categoryToAdd);
    this.setState((prevState) => {
      return {
        composers: prevState.composers.filter(
          (composer) => prevState.selectedCategories.indexOf(composer) === -1
        ),
        massParts: prevState.massParts.filter(
          (massPart) => prevState.selectedCategories.indexOf(massPart) === -1
        ),
        liturgicalSeason: prevState.liturgicalSeason.filter(
          (season) => prevState.selectedCategories.indexOf(season) === -1
        ),
        voicings: prevState.voicings.filter(
          (voice) => prevState.selectedCategories.indexOf(voice) === -1
        ),
      };
    });
  }
  removeCategory(categoryToRemove) {
    this.props.removeSearchQuery(categoryToRemove);
    const newselectedCategories = this.state.selectedCategories.filter(
      (category) => category !== categoryToRemove
    );
    this.setState({
      selectedCategories: newselectedCategories,
    });
    const voicings = tags.voicings;
    const composers = tags.composers;
    const liturgicalSeason = tags.liturgicalSeason;
    const massParts = tags.massParts;
    const scripture = tags.scripture;

    if (composers.indexOf(categoryToRemove) > -1) {
      this.setState((prevState) => {
        return {
          composers: [...prevState.composers, categoryToRemove],
        };
      });
    }
    if (voicings.indexOf(categoryToRemove) > -1) {
      this.setState((prevState) => {
        return {
          voicings: [...prevState.voicings, categoryToRemove],
        };
      });
    }
    if (liturgicalSeason.indexOf(categoryToRemove) > -1) {
      this.setState((prevState) => {
        return {
          liturgicalSeason: [...prevState.liturgicalSeason, categoryToRemove],
        };
      });
    }
    if (massParts.indexOf(categoryToRemove) > -1) {
      this.setState((prevState) => {
        return {
          massParts: [...prevState.massParts, categoryToRemove],
        };
      });
    }
    if (scripture.indexOf(categoryToRemove) > -1) {
      this.setState((prevState) => {
        return {
          scripture: [...prevState.scripture, categoryToRemove],
        };
      });
    }
  }
  renderDropDowns(name, _items) {
    const items = [...new Set([..._items])];
    if (window.innerWidth < 979) {
      return (
        <TabletDropdown
          tags={items}
          addToState={this.addCategory}
          removeFromState={this.removeCategory}
          removeActiveClass
          name={name}
        />
      );
    } else {
      return (
        <CheckboxHolder>
          <button className="btn">{name}</button>
          <div className="checkbox-list">
            <RenderCheckboxes
              tags={items}
              addToState={this.addCategory}
              removeFromState={this.removeCategory}
              removeActiveClass
            />
          </div>
        </CheckboxHolder>
      );
    }
  }
  render() {
    return (
      <div className="filter-cards">
        <div
          className={`checkboxes ${
            window.innerWidth < 979 ? "checkboxes--tablet" : ""
          }`}
        >
          {this.renderDropDowns("scripture", this.state.scripture)}
          {this.renderDropDowns("composer", this.state.composers)}
          {this.renderDropDowns("voicing", this.state.voicings)}
          {this.renderDropDowns(
            "liturgical season / Feast",
            this.state.liturgicalSeason
          )}
          {this.renderDropDowns("additional tags", this.state.massParts)}
        </div>
        <div>
          <Search
            removeCategory={this.removeCategory}
            selectedCategories={this.state.selectedCategories}
          />
        </div>
      </div>
    );
  }
}

export default FilterCards;



// WEBPACK FOOTER //
// ./src/components/FilterCards.js